<template>
    <flex-layout>
        <InvestorRelationModal />
        <page-header heading="Investor Relation" action="Add" toggle="offcanvas" target="#offcanvasCreate" :guard="this.$route.meta.guard"
            @click="setCreateForm" />

        <InvestorRelationTable :tableHeading="tableHeading" />
    </flex-layout>
</template>
  
<script>
import FlexLayout from "@/components/Layout/FlexLayout.vue";
import InvestorRelationTable from "@/components/InvestorRelation/table.vue";
import PageHeader from "@/components/Utility/PageHeader.vue";
import InvestorRelationModal from "@/components/InvestorRelation/modal.vue";
export default {
    name: "InvestorRelation",
    components: {
        PageHeader,
        FlexLayout,
        InvestorRelationTable,
        InvestorRelationModal
    },
    data() {
        return {
            tableHeading: [
                {
                    heading: "Title",
                },
                {
                    heading: "Parent",
                },
                {
                    heading: "File",
                },
                {
                    heading: "Status",
                },
            ],
        };
    },

    methods: {
        setCreateForm() {
            this.$root.$emit('CREATE');
        }
    }
};
</script>
  